import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface GetVerifiedPhonesResponse extends BackendResponse {
  phones: string[];
}

export interface GetVerifiedPhonesParameters extends NextApiParams {}

export const getVerifiedPhones = withNextApi<
  GetVerifiedPhonesResponse,
  GetVerifiedPhonesParameters
>("/auth/GetVerifiedPhones", {
  method: "GET",
});
